import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {BlockTemplateComponent} from 'src/app/components/block-template/block-template/block-template.component';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  // styleUrls: ['./auth-layout.component.scss']
})
export class AuthLayoutComponent implements OnInit, OnDestroy {
  test: Date = new Date();
  public isCollapsed = true;

  constructor(
    private router: Router,
    private _spinnerSevice: SpinnerService,
  ) {}

  blockTemplate: BlockTemplateComponent | undefined;
  mensagemSpinner$ = this._spinnerSevice.mensagem$;
  ngOnInit() {}

  ngOnDestroy() {}
}
